<template>
    <div class="Countdown">
        <div class="text" v-if="applyState === 'ing'">剩余时间</div>
        <div class="text" v-if="applyState === 'start'">开始时间</div>
        <!-- <div class="text" v-if="applyState == 'end'">已结束</div> -->
        <ul class="cutdown_left_time" v-if="applyState === 'ing'">
            <li
                    class=""
                    v-for="(item, index) in countDownDatas"
                    :key="index"
            >
                <span class="valueBg">{{item.value}}</span>
                <span>{{item.name}}</span>
            </li>
        </ul>
        <ul class="cutdown_left_time cutdown_left_time2" v-if="applyState == 'start'">
            <li
                    class=""
                    v-for="(item, index) in startDate"
                    :key="index"
            >{{item}}
            </li>
        </ul>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "Countdown",
        data() {
            return {
                countDownDatas: [],
                is_start: false,
            };
        },
        /*
        props : {
            CountdownInfo : Object
        },
        */
        created() {
        },
        watch: {
            init: {
                handler(val) {
                    if (val && this.applyState != "start") {
                        this.formatTime();
                    }
                },
                immediate: true,
            },
        },
        computed: {
            ...mapState(["endTime", "startTime", "init", "applyState"]),
            startDate() {
                var d = new Date(this.startTime);

                return (
                    [d.getFullYear(), '年', d.getMonth() + 1, '月', d.getDate(), '日']
                );
            },
        },
        methods: {
            formatTime() {
                var nowTime = new Date().getTime();
                var lefttime = parseInt((this.endTime - nowTime) / 1000);
                var d = parseInt(lefttime / (24 * 60 * 60));
                var h = parseInt((lefttime / (60 * 60)) % 24);
                var m = parseInt((lefttime / 60) % 60);
                var s = parseInt(lefttime % 60);

                if (lefttime <= 0) {
                    d = h = m = s = 0;
                }

                this.countDownDatas = [];
                this.countDownDatas.push({
                    name: "天",
                    value: d,
                });

                this.countDownDatas.push({
                    name: ":",
                    value: h,
                });

                this.countDownDatas.push({
                    name: ":",
                    value: m,
                });

                this.countDownDatas.push({
                    name: "",
                    value: s,
                });

                if (lefttime <= 0) {
                    this.$store.commit("setApplyState", "end");
                    return;
                }

                this.time = setTimeout(() => {
                    this.formatTime();
                }, 1000);
            },
        },

        components: {},
        destroyed() {
            if (this.time) {
                clearTimeout(this.time);
                this.time = null;
            }

            console.log("destroyed  countdown");
        },
    };
</script>

<style lang="scss" scoped>
    .Countdown {
        display: flex;
        align-items: center;
        margin: 0 auto;
        justify-content: center;

        .text {
            font-size: .3rem;
            font-weight: bold;
            color: #fff;
            line-height: 3.9vw;
            padding-right: .2rem;
        }
    }

    .cutdown_left_time {
        display: flex;
        justify-content: center;
        align-items: center;
        height: .42rem;
        font-size: .28rem;
        border-radius: .05rem;
        color: #fff;
        font-weight: bold;
        border: .015rem solid #fff;
        padding: .1rem 0;

        li {
            span {
                text-align: center;
                padding: 0 .08rem;
            }

            &:first-child {
                padding-right: .15rem;
                span {
                    position: relative;
                    padding: 0 .2rem;
                    &:after{
                        position: absolute;
                        display: inline-block;
                        right: 0;
                        top: .06rem;
                        content: '';
                        width: 1px;
                        height: 70%;
                        border-right: 1px dashed rgba(255, 255, 255, .8);
                    }
                }
            }
        }
    }


    .cutdown_left_time2 {
        li {
            font-weight: bold;
            color: #fff;
            padding: 0 0.06rem;
            border-right: 1px dashed rgba(255, 255, 255, .8);
            margin-right: 0!important;
            &:last-child {
                border-right: none;
            }
        }
    }

    .startDate {
        font-size: .4rem;
        color: #0c73d8;
        display: flex;
        justify-content: center;
    }
</style>
